var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PSelect',{attrs:{"disabled":_vm.disabled,"items":_vm.countries,"label":_vm.label,"required":_vm.required,"itemText":"text","itemValue":"value"},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}})
}
var staticRenderFns = []

export { render, staticRenderFns }